import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectDriverAssignmentsListOptions,
  setListOptions,
  selectDriverAssignmentsListStructure,
} from '@/features/domain/lists'
import { useEditingStateWithCtx } from '@/atoms'
import { useAppDispatch } from '@/store'

export function useSorter() {
  const listOptions = useSelector(selectDriverAssignmentsListOptions)
  const listStructure = useSelector(selectDriverAssignmentsListStructure)
  const { editing } = useEditingStateWithCtx('order')
  const dispatch = useAppDispatch()

  const [direction, setDirection] = useState(() => listOptions.sort[0].direction)

  useEffect(() => {
    if (!listOptions.sort) return
    if (listOptions.sort[0].direction === direction) return

    dispatch(
      setListOptions({
        category: 'driverAssignments',
        options: {
          ...listOptions,
          sort: [
            { ...listOptions.sort[0], direction },
            {
              field: 'ui.sort.value',
              direction,
            },
          ],
        },
      }),
    )
  }, [dispatch, direction, listOptions])

  return { editing, direction, setDirection, noEntries: listStructure.totalItems === 0 }
}
